export default __webpack_public_path__ + "static/media/ideas.ab1c4b96.svg";